import { useState } from "react";
import SmartGrid from "./components/SmartGrid";
import { FaUser } from "react-icons/fa";
import { TABLE_DATA } from "./components/SmartGrid/constants";

const App = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading] = useState(false);

  // Sample configuration
  const initialConfig = {
    title: "Smart Grid",
    columns: [
      {
        label: "Name",
        key: "name",
        width: "200px",
        customCellRenderer: (row) => (
          <div className="flex items-center">
            <FaUser className="mr-2 text-primary" />
            <span>{row.name}</span>
          </div>
        ),
        pin: "left",
        isEditable: true,
        filter: true,
      },
      {
        label: "Email",
        key: "email",
        width: "250px",
        isEditable: true,
        filter: true,
        maxLength: 20,
      },
      {
        label: "Phone",
        key: "phone",
        width: "150px",
        isEditable: true,
        filter: true,
      },
      {
        label: "Age",
        key: "age",
        width: "100px",
        isEditable: true,
        filter: true,
      },
      {
        label: "Status",
        key: "status",
        width: "120px",
        cellType: "status",
        isEditable: true,
      },
      {
        label: "Department",
        key: "department",
        width: "180px",
        isEditable: true,
      },
      {
        label: "Joined Date",
        key: "joinedDate",
        width: "150px",
        isEditable: true,
      },
    ],
    pagination: {
      pageSize: 10,
    },
    searchable: true,
    showRowSelection: true,
    exportDateField: "joinedDate",
    toastDuration: 3000,
    showActions: true,
  };

  // Sample data
  const [data] = useState(TABLE_DATA);

  // handlers
  const handleRowSelection = (rows) => {
    setSelectedRows(rows);
  };

  const handleDeleteSelectedRows = (rows) => {
    console.log(rows);
  };

  const handleUpdateRow = (data, id) => {
    console.log(data, id);
  };

  const handleDeleteRow = (id) => {
    console.log(id);
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-3 text-primary">
        Smart Grid Component
      </h1>
      <p className="mb-6 text-gray-600">
        A fully configurable table component with search, filtering, pagination,
        CSV/Excel export, and more. Click the Settings icon to view and edit the
        configuration.
      </p>

      <SmartGrid
        initialConfig={initialConfig}
        initialData={data}
        handleRowSelection={handleRowSelection}
        selectedRows={selectedRows}
        handleDeleteSelectedRows={handleDeleteSelectedRows}
        handleUpdateRow={handleUpdateRow}
        isLoading={isLoading}
        handleDeleteRow={handleDeleteRow}
      />
    </div>
  );
};

export default App;
